import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { topics } from "@/mocks/cases";

export default function TopicCollections() {
  return (
    <section id="topics" className="w-full bg-foreground-950">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="03"
          title="专题合辑 · 一次看个够"
          subtitle="把零散的现场按主题串成完整脉络，适合下班路上一次性刷完。"
          invert
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {topics.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 80}>
              <a
                href="#featured"
                className="group relative flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-800 bg-background-900"
              >
                <div className="relative h-48 w-full overflow-hidden md:h-52">
                  <img
                    src={topic.cover}
                    alt={`专题合辑配图：${topic.title}`}
                    title={`${topic.title} · 曝光档案局专题`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/30 to-transparent" />
                  <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-semibold text-accent-950">
                    <i className="ri-bookmark-3-fill" />
                    {topic.label}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-bold leading-snug text-background-50 transition-colors group-hover:text-primary-300">
                    {topic.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-background-300">{topic.desc}</p>
                  <div className="mt-5 flex items-center justify-between border-t border-background-800 pt-4">
                    <span className="inline-flex items-center gap-1.5 text-xs text-background-300">
                      <i className="ri-file-list-3-line" />
                      收录 {topic.count} 篇
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-300">
                      进入现场列表
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}